import React from 'react';
import './SceneIndoorHotspot.scss';

const SceneIndoorHotspot = ({ scene, onClick }) => {
  return (
    <div className="khp-indoor-hotspot" onClick={onClick}>
      <div className="khp-indoor-hotspot__pulse">&nbsp;</div>
    </div>
  );
};

export default SceneIndoorHotspot;
